import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints, BreakPointsMFirst } from '~/src/constants/breakpoints';
import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

type TImgBlock = {
    webpImg?: string,
    pngImg?: string,
}

type TTextColor = {
    textColor?: string,
}

export const RoutersBannersContainer = styled.div`
    width: 100%;
    box-sizing: content-box;
    margin: 64px 0;
`;

export const RoutersBannersBlock = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    grid-gap: 24px;
    width: 100%;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
        flex-wrap: wrap;
        grid-gap: 18px;
    }
`;

export const ImgBlock = styled.div`
    width: 40%;
    height: 100%;

    @media (max-width: ${BreakPointsMFirst.tablet}) {
        width: 50%;
    }
`;

export const Image = styled(LazyLoadImage)`
    object-fit: cover;
    object-position: right;
    width: 100%;
    height: 100%;
    border-radius: ${BorderRadius.OuterBlockRadius} 0 0 ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${breakPoints.sMobile}) {
        object-position: 93% 100%;
    }
`;

export const TextBlock = styled.div`
    width: 60%;

    @media (max-width: ${BreakPointsMFirst.tablet}) {
        width: 50%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        width: 80%;
    }
`;

export const ContentWrap = styled.div<TImgBlock>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    border-radius: ${BorderRadius.OuterBlockRadius};
    height: auto;
    ${(props) => (props.pngImg || props.webpImg) && css`
        background-image: url('${useProgressiveImage(props.webpImg, { hasTimeout: true, timeoutDelay: 1 }, props.pngImg)}');
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;

        @media (max-width: ${BreakPointsMFirst.sDesktop}) {
            overflow: hidden;
        }

        @media (max-width: ${breakPoints.mobile}) {
            width: 100%;
        }
    `};
`;

export const Title = styled.div<TTextColor>`
    ${(props) => props.textColor && css`
        color: ${props.textColor};
        padding: 40px 10px 8px 20px;
        ${FONTS.H4};

        @media (max-width: ${BreakPointsMFirst.sDesktop}) {
            padding-left: 0;
        }

        @media (max-width: ${breakPoints.tablet}) {
            ${FONTS.H5};
            padding: 24px 5px 8px 0;
        }

        @media (max-width: ${breakPoints.sMobile}) {
            margin-left: -5px;
            ${FONTS.H4};
        }
    `};
`;

export const SubText = styled.div<TTextColor>`
    ${(props) => props.textColor && css`
        color: ${props.textColor};
        padding: 0 20px 40px 20px;
        ${FONTS.XS};

        @media (max-width: ${BreakPointsMFirst.sDesktop}) {
            padding-left: 0;
        }

        @media (max-width: ${breakPoints.tablet}) {
            padding: 0 5px 32px 0;
        }

        @media (max-width: ${breakPoints.sMobile}) {
            margin-left: -5px;
        }
    `};
`;
